module.exports = __webpack_public_path__ + "58281f272cef18e03f7c6dd4fba032af.svg";